module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/074-kazakhstan-f46ab3888cc1ef46cfdeaab8ac8e6326.svg";